import css from 'styled-jsx/css';

const styles = css.global`#den-fraudes-boleto-seguro {
  padding-top: 56px;
  padding-bottom: 56px;
}

#den-fraudes-boleto-seguro .boleto-seguro-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin: 0;
}

#den-fraudes-boleto-seguro .boleto-seguro-subtitulo {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#den-fraudes-boleto-seguro .boleto-seguro-cards {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;
  flex-wrap: wrap;
  justify-content: space-between;
}

#den-fraudes-boleto-seguro .boleto-seguro-card {
  max-width: 297px;
}

#den-fraudes-boleto-seguro .boleto-seguro-card .boleto-seguro-card-titulo {
  display: flex;
  gap: 16px;
  align-items: center;
}

#den-fraudes-boleto-seguro .boleto-seguro-card-titulo-texto {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#den-fraudes-boleto-seguro .boleto-seguro-card-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 8px;
}

#den-fraudes-boleto-seguro .boleto-seguro-denuncia {
  border-radius: 4px;
  background: #444;
  padding: 32px 24px;
  margin-top: 40px;
}

#den-fraudes-boleto-seguro .boleto-seguro-titulo-denuncia {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 16px;
}

#den-fraudes-boleto-seguro .boleto-seguro-subtitulo-denuncia {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#den-fraudes-boleto-seguro .boleto-seguro-subtitulo-denuncia a {
  text-decoration: underline;
}


@media (min-width: 992px) {


  #den-fraudes-boleto-seguro .boleto-seguro-cards {
    flex-direction: row;
  }

  #den-fraudes-boleto-seguro .boleto-seguro-cards {
    margin-top: 64px;
    gap: 64px;
  }

  #den-fraudes-boleto-seguro .boleto-seguro-card-texto {
    margin-top: 24px;
  }

  #den-fraudes-boleto-seguro .boleto-seguro-denuncia {
    display: flex;
    align-items: center;
    gap: 56px;
    justify-content: center;
    height: 140px;
    max-width: 1204px;
    margin: 72px auto 0;
  }

  #den-fraudes-boleto-seguro .boleto-seguro-card br,
  #den-fraudes-boleto-seguro .boleto-seguro-denuncia br {
    display: none;
  }

  #den-fraudes-boleto-seguro .boleto-seguro-titulo-denuncia {
    margin-bottom: 0;
  }

  #den-fraudes-boleto-seguro .boleto-seguro-subtitulo-denuncia {
    max-width: 670px;
  }

  #den-fraudes-boleto-seguro {
    padding-top: 88px;
    padding-bottom: 88px;
  }

}

@media (min-width: 1215px) {

  #den-fraudes-boleto-seguro .boleto-seguro-card.extendido {
    max-width: 435px;
  }
}`;

export default styles;